import * as React from 'react';
import '../css/SuperUserPageView.css';
import { connect, ConnectedProps } from 'react-redux';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {IProduct, ITagline, ProductLine} from "../../../infrastructure/interfaces";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";
import TaglineEditorModal from "../../Modals/TaglineEditorModal";
import {deleteTagline, saveTagline} from "../../../actions/actions";

export interface ITaglineTableState {
    previewingProduct: IProduct | null;
    productsFilter: string;
    typesFilter: string;
    categoryFilter: string;
    publishedFilter: string;
    showTaglineEditorModal: boolean;
    showDeleteTaglineModal: boolean;
    taglineToDelete: ITagline | undefined;
    taglineToEdit: ITagline | undefined;
}

interface TaglinesTableStateProps {
    taglines: ITagline[];
}
const mapStateToProps = (state: any): TaglinesTableStateProps => {
    return {
        taglines: state.wizard.taglines,
    };
};

interface TaglinesTableDispatchProps {
    deleteTagline(Tagline: ITagline): void;
    saveTagline(Tagline: ITagline): void;
}
const mapDispatchToProps = (dispatch: any): TaglinesTableDispatchProps => {
  return {
    deleteTagline: (Tagline: ITagline) => {
      dispatch(deleteTagline(Tagline));
    },
    saveTagline: (Tagline: ITagline) => {
      dispatch(saveTagline(Tagline));
    },
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type ITaglineTableProps = PropsFromRedux & {
};

class TaglinesTable extends React.Component<ITaglineTableProps, ITaglineTableState> {
  tableRow: HTMLElement;

  constructor(props: ITaglineTableProps) {
    super(props);

    this.state = {
      previewingProduct: null,
      productsFilter: '',
      typesFilter: '',
      categoryFilter: '',
      publishedFilter: '',
      showTaglineEditorModal: false,
      showDeleteTaglineModal: false,
      taglineToDelete: undefined,
      taglineToEdit: undefined,
    };
  }

  onEditTagline(tagline: ITagline) {
      this.setState({
          showTaglineEditorModal: true,
          taglineToDelete: undefined,
          taglineToEdit: tagline,
      });
  }

  onCreateTagline() {
      this.setState({
          showTaglineEditorModal: true,
          taglineToDelete: undefined,
          taglineToEdit: undefined,
      });
  }

  onDeleteTagline(tagline: ITagline) {
      this.setState({
          showDeleteTaglineModal: true,
          taglineToDelete: tagline,
          taglineToEdit: undefined,
      });
  }

  closeModals = () => {
      this.setState({
        showTaglineEditorModal: false,
        showDeleteTaglineModal: false,
        taglineToDelete: undefined,
        taglineToEdit: undefined,
      });
  };

  render() {
    const TaglinesSafe: ITagline[]  = this.props.taglines ? this.props.taglines : [];

    return (
      <div className="inner-su-container">
        <div className="manage-items-row-offsetRight">
          <div className="in-row-text-container-products">
            Manage Taglines
          </div>

          <div className="in-row-button-container">
            <button
                className="btn primary-green large"
                onClick={() => this.onCreateTagline()}
                title={TooltipCont.CREATE_TAGLINE}
              >
                Create New Tagline
            </button>
          </div>
        </div>

        <DeleteConfirmModal
            show={this.state.showDeleteTaglineModal}
            onClose={ this.closeModals }
            onSave={() => {
                if (!!this.state.taglineToDelete) {
                  this.props.deleteTagline(this.state.taglineToDelete);
                }
                this.closeModals();
            }}
            title="Delete Tagline?"
        />

        <TaglineEditorModal
            show={this.state.showTaglineEditorModal}
            onClose={ this.closeModals }
            tagline={this.state.taglineToEdit}
            onSave={(Tagline: ITagline) => {
                this.props.saveTagline(Tagline);
                this.closeModals();
            }}
        />
  
        <table className="table-scrollableSU documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th className="TaglineDescription">Details</th>
              <th className="TaglineType">Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {TaglinesSafe.map((d, index, array) =>
              <tr key={d.id} ref={tr => this.tableRow = tr!}>
                <td className="TaglineDescription" dangerouslySetInnerHTML={{__html:d.title}} />
                <td className="TaglineDescription" dangerouslySetInnerHTML={{__html:(d.productLine  == ProductLine.LOVELAND ? "Loveland" : "Seed")}} />
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onEditTagline(d)}
                      title={TooltipCont.EDIT}
                      disabled={false}
                    >
                      Edit
                    </button>

                    <button
                        className="btn primary-red"
                        onClick={() => this.onDeleteTagline(d)}
                        title={TooltipCont.DELETE}
                        disabled={false}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>);
  }
}
export default connector(TaglinesTable);



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/TaglinesTable.tsx